import {Alert, Checkbox, FlexColumn, Label, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {hasRemovedListVisibility, isOpportunityListAvailable, ListVisibility} from './listVisibility';

type ListVisibilitySectionProps = {
	value: ListVisibility;
	onChange: (value: ListVisibility) => void;
	// Edit only: the values the modal opened with, so unticking one of them can warn.
	initialValue?: ListVisibility;
};

export const ListVisibilitySection = ({value, onChange, initialValue}: ListVisibilitySectionProps): React.JSX.Element => {
	const {formatMessage} = useIntl();
	const showRemovalWarning = !!initialValue && hasRemovedListVisibility(initialValue, value);

	const opportunityLabel = formatMessage({id: 'settings.custom-fields.list_visibility.opportunity_list'});
	const projectLabel = formatMessage({id: 'settings.custom-fields.list_visibility.project_list'});

	return (
		<div data-cy={'custom-field-list-visibility'}>
			<FlexColumn gap={'s'}>
				<Label size={'2'}>{formatMessage({id: 'settings.custom-fields.list_visibility.title'})}</Label>
				<Text size="2" color="auxiliary">
					{formatMessage({id: 'settings.custom-fields.list_visibility.helper_text'})}
				</Text>
				{isOpportunityListAvailable() && (
					<Checkbox
						checked={value.showOnOpportunityList}
						onChange={() => onChange({...value, showOnOpportunityList: !value.showOnOpportunityList})}
						labelText={opportunityLabel}
						aria-label={opportunityLabel}
						notBoldLabel={true}
						data-cy={'custom-field-show-on-opportunity-list'}
					/>
				)}
				<Checkbox
					checked={value.showOnProjectList}
					onChange={() => onChange({...value, showOnProjectList: !value.showOnProjectList})}
					labelText={projectLabel}
					aria-label={projectLabel}
					notBoldLabel={true}
					data-cy={'custom-field-show-on-project-list'}
				/>
				{showRemovalWarning && (
					<Alert
						type={Alert.TYPE.WARNING}
						text={formatMessage({id: 'settings.custom-fields.list_visibility.removal_warning'})}
					/>
				)}
			</FlexColumn>
		</div>
	);
};
